/**
 * Created by tanbingqin on 2018/5/8.
 */
import { fetch } from 'utils/fetch';
//获取公司详情
export const getCompanyInfo = (companyOID) => {
  if (!companyOID) return;
  return fetch({
    url: `/api/companies/noAuthorities/${companyOID}`,
    method: 'GET',
  });
};
export const fetchCorporation = (corporation) => {
  if (!corporation) return;
  return fetch({
    url: `/api/my/company/receipted/invoice/${corporation}`,
    method: 'GET',
  });
};
export const fetchApproverApi = (userOIDs) => {
  if (!userOIDs) return;
  return fetch({
    url: `/api/users/oids?userOIDs=${userOIDs}`,
    method: 'GET',
  });
};
export const fetchCustomEnumerationApi = (customEnumerationOID, value) => {
  if (!value) return;
  return fetch({
    url: '/api/custom/enumerations/items?customEnumerationOID=' + customEnumerationOID + '&messageKey=' + value,
    method: 'GET',
  });
};
export const fetchCostItemApi = (costCenterOID) => {
  if (!costCenterOID) return;
  return fetch({
    url: '/api/cost/center/item/' + costCenterOID,
    method: 'GET',
  });
};
export const fetchBankAccountApi = (bankId) => {
  if (!bankId) return;
  return fetch({
    url: '/api/contact/bank/account/' + bankId,
    method: 'GET',
  });
};
export const fetchPayeeApi = (PayeeId) => {
  if (!PayeeId) return;
  return fetch({
    url: '/supplier/api/ven/infoBank?vendorInfoId=' + PayeeId,
    method: 'GET',
  });
};
/**
 * 获取公司账户信息
 * @param {String} companyReceiptedOID 公司账户信息OID
 */
export const getCompanyReceiptedInvoicesByReceiptedOID = (companyReceiptedOID) => {
  return fetch({
    url: `/api/company/receipted/invoices/users/${companyReceiptedOID}`,
    method: 'GET',
  });
};
export const getCompanyReceiptedInvoices = ({ pageNum = 0, pageSize = 20, keyword }) => {
  return fetch({
    url: '/api/v2/my/company/receipted/invoices',
    method: 'GET',
    params: {
      pageNum,
      pageSize,
      keyword,
    },
  });
};
/**
 * 获取当前用户所在租户下的公司名
 */
export const getCompanyList = ({
  page,
  size,
  roleType = 'TENANT',
  setOfBooksId,
  keyword = '',
  isFullInfo = true,
  enabled = true,
}) => {
  return fetch({
    url: '/api/company/by/term',
    method: 'GET',
    params: {
      page,
      size,
      roleType,
      setOfBooksId,
      name: keyword,
      enabled: enabled,
      isFullInfo,
    },
  });
};
/**
 * 8199需求
 * 获取公司列表（新）
 * @param {Object} data 分页及userOID
 */
export const getNewComponeyList = ({ userOID, page, size, keyword, jobId }) => {
  let jobIdChanged = jobId;
  if (!jobId) {
    jobIdChanged = -999;
  }

  return fetch({
    url: '/api/widget/company/all',
    method: 'GET',
    params: {
      userOID,
      enabled: true,
      page,
      size,
      keyword,
      jobId: jobIdChanged,
      queryType: 'SETOFBOOKS',
    },
  });
};
/**
 * 获取申请人所在公司组的公司列表接口
 * @param {Object} data 分页及userOID
 */
export const getComponeyGroupList = ({ userOID, page, size, keyword, jobId }) => {
  return fetch({
    url: '/api/widget/company/all',
    method: 'GET',
    params: {
      userOID,
      page,
      size,
      keyword,
      jobId,
      queryType: 'GROUP',
      enabled: true,
    },
  });
};
/**
 * 获取所有币种信息
 * @returns {*}
 */
export const getAllCurrency = () => {
  return fetch({
    url: '/api/currencyI18n',
    method: 'GET',
  });
};

export const getBankListFromLoan = ({ page, size, companyOID, setOfBooksId, keyword, companyIdList, ...rest }) => {
  return fetch({
    url: '/api/CompanyBank/queryRepaymentCompanyBank',
    method: 'GET',
    params: {
      companyOID,
      setOfBooksId,
      page,
      size,
      keyword,
      companyIdList,
      ...rest,
    },
  });
};

/**
 * 获取公司相关的银行账户列表
 */
export const getBankListByCompanyOID = ({
  companyOID,
  companyCode,
  companyName,
  companyBankName,
  companyBankCode,
  setOfBooksId,
  currency,
  isEnabled = true,
  page,
  size,
}) => {
  return fetch({
    url: '/api/CompanyBank/selectByCompanyOID',
    method: 'GET',
    params: {
      companyOID,
      companyCode,
      companyName,
      companyBankName,
      companyBankCode,
      setOfBooksId,
      currency,
      isEnabled,
      page,
      size,
    },
  });
};

/**
 * 获取同租户内公司
 */
export const getTenantComponeyList = (params) => {
  return fetch({
    url: '/api/company/controlled/by/term',
    method: 'GET',
    params,
  });
};
export const getSetOfBooksList = (params) => {
  return fetch({
    url: '/api/setOfBooks/query/dto',
    method: 'GET',
    params,
  });
};

// 获取租户公司列表
export const getSetOfBooksCompanyList = (params) => {
  return fetch({
    url: '/api/widget/company/all',
    method: 'GET',
    params,
  });
};

// 成本中心关联公司信息
export const getConstCenterCompanyInfo = (params) => {
  return fetch({
    url: '/api/cost/center/item/check/company/associate',
    method: 'GET',
    params,
  });
};
